export { SredHomeLayout } from './SredHomeLayout';
